// src/store/formDraftSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormDraftState {
  // DiscussionBoard: questionId -> draft content
  discussionDrafts: Record<string, string>;
  // MessageBoard: questionId -> draft content
  messageDrafts: Record<string, string>;
  // 汎用的なフォームドラフト: formId -> draft content
  genericDrafts: Record<string, string>;
}

const initialState: FormDraftState = {
  discussionDrafts: {},
  messageDrafts: {},
  genericDrafts: {},
};

const formDraftSlice = createSlice({
  name: 'formDraft',
  initialState,
  reducers: {
    setDiscussionDraft(state, action: PayloadAction<{ questionId: string; content: string }>) {
      const { questionId, content } = action.payload;
      if (content.trim()) {
        state.discussionDrafts[questionId] = content;
      } else {
        delete state.discussionDrafts[questionId];
      }
    },
    clearDiscussionDraft(state, action: PayloadAction<string>) {
      delete state.discussionDrafts[action.payload];
    },
    setMessageDraft(state, action: PayloadAction<{ questionId: string; content: string }>) {
      const { questionId, content } = action.payload;
      if (content.trim()) {
        state.messageDrafts[questionId] = content;
      } else {
        delete state.messageDrafts[questionId];
      }
    },
    clearMessageDraft(state, action: PayloadAction<string>) {
      delete state.messageDrafts[action.payload];
    },
    setGenericDraft(state, action: PayloadAction<{ formId: string; content: string }>) {
      const { formId, content } = action.payload;
      if (content.trim()) {
        state.genericDrafts[formId] = content;
      } else {
        delete state.genericDrafts[formId];
      }
    },
    clearGenericDraft(state, action: PayloadAction<string>) {
      delete state.genericDrafts[action.payload];
    },
    clearAllDrafts(state) {
      state.discussionDrafts = {};
      state.messageDrafts = {};
      state.genericDrafts = {};
    },
  },
});

export const {
  setDiscussionDraft,
  clearDiscussionDraft,
  setMessageDraft,
  clearMessageDraft,
  setGenericDraft,
  clearGenericDraft,
  clearAllDrafts,
} = formDraftSlice.actions;

export default formDraftSlice.reducer;
